import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Slider from "react-slick";

import VideoSection from "./VideoSection";
import Service from "./Service";
import axios from "axios";

const Home = () => {
  const [mostProducts, setMostProducts] = useState([]);
  const [sliderImages, setSliderImages] = useState([]);
  const [error, setError] = useState("");
  const sliderRef = useRef(null);
  const URL = process.env.REACT_APP_URL;

  useEffect(() => {
    axios
      .get(`${URL}mostproduct`)
      .then((response) => {
        setMostProducts(response.data);
        setError("");
      })
      .catch((error) => {
        setError("Error fetching most sold products.");
      });
    axios
      .get(`${URL}sliderImage`)
      .then((response) => {
        setSliderImages(response.data);
        setError("");
      })
      .catch((error) => {
        setError("Error fetching most sold products.");
      });
  }, [URL]);

  // const NextArrow = ({ onClick }) => (
  //   <div
  //     onClick={onClick}
  //     style={{
  //       position: "absolute",
  //       top: "50%",
  //       right: "10px",
  //       transform: "translateY(-50%)",
  //       zIndex: 10,
  //       cursor: "pointer",
  //       color: "#fff",
  //       fontSize: "2rem",
  //     }}
  //   >
  //     {/* <i className="fa-solid fa-play" style={{color:"white"}}></i> */}
  //     <i
  //       className="fa-solid fa-chevron-right"
  //       style={{ color: "white", fontSize: "7vh" }}
  //     ></i>
  //   </div>
  // );
  const productSliderSettings = {
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
    arrows: false,  
  };

  // const PrevArrow = ({ onClick }) => (
  //   <div
  //     onClick={onClick}
  //     style={{
  //       position: "absolute",
  //       top: "50%",
  //       left: "10px",
  //       transform: "translateY(-50%)",
  //       zIndex: 10,
  //       cursor: "pointer",
  //       color: "#fff",
  //       fontSize: "2rem",
  //     }}
  //   >
  //     <i
  //       className="fa-solid fa-chevron-left"
  //       style={{ color: "white", fontSize: "7vh" }}
  //     ></i>
  //   </div>
  // );
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,

  };
  
  return (
    <div>
      <section>
        <Box
          sx={{ maxWidth: "100%", position: "relative", overflow: "hidden" }}
        >
          {/* Slider Component */}
          <Slider {...sliderSettings} ref={sliderRef}>
            {sliderImages.map((slide) => (
              <Box
                key={slide.id}
                sx={{ position: "relative", textAlign: "center" }}
              >
                <img
                  src={`${URL}upload/${slide.image || "default.jpg"}`}
                  alt={slide.title}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/images/2.jpg"; // Fallback image
                  }}
                  style={{
                    width: "100%",
                    height: "80vh",
                    objectFit: "cover",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: "80%",
                    left: "25%",
                    transform: "translate(-50%, -50%)",
                    color: "#fff",
                    borderRadius: "10px",
                    textAlign: "left",
                    width: {
                      xs: "30%", // Full width on small screens
                      sm: "30%", // Reduced width on medium screens
                      md: "30%", // Half width on larger screens
                    },
                  }}
                >
                  <Typography
                    variant="h1"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                    }}
                  >
                    {slide.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "white",
                      fontSize: { xs: "0.8rem", sm: "1rem", md: "1.2rem" },
                      marginTop: "10px",
                    }}
                  >
                    {slide.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      </section>
      {/* Product Section */}
      <section className="services-section">
        <div className="container">
        <div className="title-box">
            <h2>Timeless Designs & Exceptional Craftsmanship</h2>
          </div>


          <Slider {...productSliderSettings}>
            {error ? (
              <div className="text-danger text-center ">{error}</div>
            ) : (
              mostProducts.map((product) => (
                <div key={product.id} className="px-2">
                  <div className="card shadow-sm mb-3 mt-2 border border-secondary rounded h-100">
                    <img
                      style={{ height: "30vh", objectFit: "cover" }}
                      src={`${URL}upload/${product.image || "default.jpg"}`}
                      alt={product.title}
                      className="card-img-top"
                    />
                    <div
                      className="card-body d-flex flex-column justify-content-center text-center"
                      style={{ height: "20vh" }}
                    >
                      <h5 className="card-title">{product.title}</h5>
                      <p className="card-text">{product.description}</p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </Slider>
        </div>
      </section>

      <Service />
      <VideoSection />
      {/* <CustomerReview /> */}
      <section
        className="call-to-action-section col-lg-12 col-md-12 col-sm-12"
        style={{ backgroundImage: `url(/images/Banner.png)` }}
      >
        <div className="auto-container">
          <h2>Think Jewelry. Think Elegance.</h2>
          <div className="text">
            Discover the finest jewelry collections for all styles and budgets.
            Heart your favorites to shortlist.
          </div>
          <Link to="/contact" className="theme-btn btn-style-two">
            <span className="txt">Contact Us</span>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
